import { createMachine } from 'xstate';

import { assignFactory } from '../../shared/utils/utils';
import { services } from './intializeMachine.services';

export const initializeMachine = createMachine({
  id: 'initializeMachine',
  initial: 'gettingConfig',
  context: {},
  states: {
    gettingConfig: {
      invoke: {
        src: services.gettingConfig,
        onDone: {
          target: 'gettingObjects',
          actions: assignFactory('config'),
        },
        onError: {
          target: 'failure',
          actions: assignFactory('error'),
        },
      },
    },
    gettingObjects: {
      invoke: {
        src: services.gettingObjects,
        onDone: {
          target: 'gettingLoginData',
          actions: assignFactory('objects'),
        },
        onError: {
          target: 'failure',
          actions: assignFactory('error'),
        },
      },
    },
    gettingLoginData: {
      invoke: {
        src: services.gettingLoginData,
        onDone: {
          target: 'gettingSpecialFields',
          actions: assignFactory('loginData'),
        },
        onError: {
          target: 'failure',
          actions: assignFactory('error'),
        },
      },
    },
    gettingSpecialFields: {
      invoke: {
        src: services.gettingSpecialFields,
        onDone: {
          target: 'gettingBranchConfig',
          actions: assignFactory('updatedConfig'),
        },
        onError: {
          target: 'failure',
          actions: assignFactory('error'),
        },
      },
    },
    gettingBranchConfig: {
      invoke: {
        src: services.gettingBranchConfig,
        onDone: {
          target: 'success',
          actions: assignFactory('branchConfig'),
        },
        onError: {
          target: 'failure',
          actions: assignFactory('error'),
        },
      },
    },
    success: {
      type: 'final',
      data: (ctx) => ({
        config: ctx.updatedConfig || [],
        objects: ctx.objects || [],
        branchConfig: ctx.branchConfig,
      }),
    },
    failure: {
      type: 'final',
      data: (ctx) => ({
        error: ctx.error || 'Server Error',
      }),
    },
  },
});
